import { useCallback } from "react";
import { useApi } from "./use-api";

export interface WebinarSummary {
  id: string;
  title: string;
  slug: string;
  type: "live" | "evergreen" | "hybrid";
  timezone: string;
  status: "draft" | "scheduled" | "live" | "ended" | "on_demand" | "cancelled";
  registrationEnabled: boolean;
  scheduledAt: string | null;
  endedAt: string | null;
  attendeeCount: number;
  registrationCount: number;
  isEvergreen: boolean;
  thumbnailUrl?: string;
}

interface WebinarListApiRecord {
  id: string;
  title: string;
  slug: string;
  type: "live" | "evergreen" | "hybrid";
  timezone: string;
  status: WebinarSummary["status"] | "cancelled";
  registrationEnabled: boolean;
  scheduledAt: string | null;
  endedAt: string | null;
}

export function useWebinarList() {
  const query = useApi<WebinarListApiRecord[]>("/v1/webinars");
  const refetch = useCallback(() => {
    query.refetch();
  }, [query]);

  return {
    data: query.data?.map((webinar) => ({
      id: webinar.id,
      title: webinar.title,
      slug: webinar.slug,
      type: webinar.type,
      timezone: webinar.timezone,
      status: webinar.status,
      registrationEnabled: webinar.registrationEnabled,
      scheduledAt: webinar.scheduledAt,
      endedAt: webinar.endedAt,
      attendeeCount: 0,
      registrationCount: 0,
      isEvergreen: webinar.type !== "live",
    })) ?? null,
    isLoading: query.isLoading,
    error: query.error,
    refetch,
  };
}
